/* eslint-disable no-unused-vars */
export const black = '#000000';
export const gold = '#FFBF06';
export const goldFont = '#FBB900';
export const lightGray = '#E6E6E6';
